<div class="page-container max-width" [class.loading]="isLoading">
    <app-header title="{{ 'time-off-v3.createTimeOffRequest' | translate }}" [back]="true"></app-header>

    <app-empty-state
        label="{{ 'time-off-v3.noTimeOffTypesCurrentlyAssigned' | translate }}"
        src="/assets/illustrations/empty-box.png"
        *ngIf="!hasPoliciesAssigned; else hasTypes"
    ></app-empty-state>

    <ng-template #hasTypes>
        <app-time-off-request
            [timeOffRequest]="timeOffRequest"
            #timeOffRequestComponent
            (save)="onSave($event)"
            (loading)="isLoading = $event"
        ></app-time-off-request>
    </ng-template>
</div>
